import reportRoutes from './reports.routes';

import reportListController from './controllers/reports.list.controller';

import reportListComponent from './components/reports.list.component';

import reportsService from './services/reports.service';

let reportModule = angular.module('spabooker.report', [ 'spabooker.base' ])
  .config(reportRoutes)

  .controller('reportListController', reportListController)

  .component('reportList', reportListComponent)

  .factory('reportsService', reportsService)
;

export default reportModule.name;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/reports/index.js